import React from "react"
import { Route } from "react-router-dom"
import { useAuth } from "./authContext"
import UnauthorizedPage from "../pages/unauthorizedPage"
import { Languages } from "../components/languages"
import { normalizePermissionGroup } from "./sessionService"
export function ProtectedRoute({

    component: Component,
    permission,
    anyOf,
    allOf,
    additionalCondition = true,
    ...rest
}) { 
    const le = Languages.ProtectedRoute[Languages.selectedLanguage];
    const auth = useAuth();
    if (!auth) {
        return null;
    }
    const { authorization, hasPermission, hasAnyPermission, hasAllPermissions } = auth;

    const normalizedAnyOf = normalizePermissionGroup(anyOf);
    const normalizedAllOf = normalizePermissionGroup(allOf);

    function isAllowed() {

        if (!additionalCondition) {
            return false;
        }

        if (permission) {
            return hasPermission(permission);
        }

        if (normalizedAnyOf.length > 0) {
            return hasAnyPermission(normalizedAnyOf);
        }

        if (normalizedAllOf.length > 0) {
            return hasAllPermissions(normalizedAllOf);
        }

        return true;
    }
    

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!authorization.isLoaded) {
                    return <div>{le.authorizationLoading}</div>;
                }

                if (!isAllowed()) {
                    return <UnauthorizedPage />;
                }
                  
                return <Component {...props } />;
            }}
        />
    );
}
